// The `|` glyph is a pseudo-element, not a text child — a real text node here would break an
// exact-match header-text locator in a browser test (`ColumnResizeHandle.tsx`). Precedent for
// drawing a glyph this way: `.react-tagsinput-tag a::before` in `libs/webui/input/src/Tags/TagsInput.scss`.
.handle {
  cursor: col-resize;
  color: var(--bs-secondary-color);

  &::before {
    content: '|';
  }
}

// Opt-in hover colour — DataTable's handle keeps its plain colour on hover; only the pivot
// grid's handle passes `hoverable` for this.
.hoverable:hover {
  color: var(--bs-link-color);
}
